const extractVideoId = (url: string): string => {
  // Handle both youtube.com and youtu.be formats
  const youtubeRegex =
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(youtubeRegex);
  return match ? match[1] : '';
};

export const sanitizeYoutubeUrl = (url: string): string => {
  const videoId = extractVideoId(url);
  return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
};
